import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginUser } from "../../api/APIServices";
import { API_STATUS } from "../../constants";

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        status:API_STATUS.IDEL,
        errorMsg:'',
        userInfo:{},
        isAuthenticated:false,
        token:'',
        locale:'en'
    },
    reducers: {
 
        logoutUser(state, action){
            state.status = API_STATUS.IDEL;
            state.isAuthenticated = false
            state.token = ''
            state.userInfo={}
            localStorage.removeItem('token');
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userInfo');
        },
     
    },
    extraReducers:(builder)=>{
        builder.addCase(loginUser.pending, (state,action)=>{           
            state.status = API_STATUS.PENDING;
       }),
        builder.addCase(loginUser.fulfilled, (state, action) => {
           
            if(action.payload?.authorization){
                localStorage.setItem('isLoggedIn', true);
                localStorage.setItem('token', action.payload?.authorization);
                localStorage.setItem('userInfo',JSON.stringify(action.payload?.user));
 
                state.isAuthenticated = true
                state.status = API_STATUS.SUCCESS;
                state.errorMsg = '';
                state.token = action.payload?.authorization
                state.userInfo = action.payload?.user
            } else {
                state.status = API_STATUS.ERROR;
                state.errorMsg = action.payload.error
            }
            
        }),
        builder.addCase(loginUser.rejected, (state, action) => {
            state.status = API_STATUS.ERROR;
            state.errorMsg = action.error
        })
    }
})


export const {logoutUser} = authSlice.actions
export default authSlice.reducer